import { schema } from "normalizr";

const JobTypeSchema = new schema.Entity("jobTypes");
const JobTypeArraySchema = new schema.Array(JobTypeSchema);

export { JobTypeSchema, JobTypeArraySchema };